export default {
    state() {
        return {
            isGuest: true,
            roles: [],
            permissions: [],
            email: '',
            name: '',
            photo: '',
            id: 0
        }
    },
    getters: {
        can: state => rule => {
            let result = false

            if (rule === 'isGuest') return state[rule]

            state.roles.some(item => result = item === rule)
            if (!result) state.permissions.some(item => result = item === rule)

            return result
        },
        email: state => state.email,
        user: state => prop => state[prop]
    },
    mutations: {
        initAccessState(state, response) {
            state.isGuest = response.isGuest
            state.roles = response.roles
            state.permissions = response.permissions
            state.name = response.name
            state.photo = response.photo
            state.id = response.id
        },
        email(state, email) {
            state.email = email
        }
    },
    actions: {
        initAccess(context, response) {
            context.commit('initAccessState', response)
        },
        setEmail(context, email) {
            context.commit('email', email)
        }
    }
}